/**
 * Formats a raw assessment answer as text
 *
 * @param {Any}    answer     the raw answer from the assessment answers map
 * @param {Array}  options    the question's options
 * @param {String} labelKey   the option field shown to the user
 * @param {String} valueKey   the option field stored in the answer
 *
 * @returns {String} the displayable answer
 */
export default function formatAssessmentAnswer(answer, { options, labelKey, valueKey } = {}) {
  const label = labelKey || "value";
  const value = valueKey || "id";

  if (Array.isArray(answer)) {
    return answer
      .map((item) => (item && typeof item === "object" ? item[label] : item))
      .filter(Boolean)
      .join(", ");
  }

  if (answer === null || answer === undefined || answer === "") return answer;

  const option = options?.find((item) => String(item[value]) === String(answer));

  return option ? option.label || option[label] : answer;
}
